import $ from 'jquery';

// --------------------------------------------------
// Timeline
// Horizontal-scroll timeline for the Timeline page-builder component.
// Prev/next arrows scroll the native overflow-x track (so touch-swipe and
// keyboard scrolling come for free). The controls hide when the track
// doesn't overflow, and each arrow disables at its end. Supports multiple
// timelines on a page.
// --------------------------------------------------

const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
).matches;

$(function () {
  $('[data-timeline]').each(function () {
    const $timeline = $(this);
    const track = $timeline.find('[data-timeline-track]')[0];

    if (!track) {
      return;
    }

    const $controls = $timeline.find('.timeline__controls');
    const $prev = $timeline.find('[data-timeline-prev]');
    const $next = $timeline.find('[data-timeline-next]');

    function update() {
      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;
      const overflowing = max > 1;

      $controls.css('display', overflowing ? '' : 'none');
      $prev.prop('disabled', x <= 1);
      $next.prop('disabled', x >= max - 1);
    }

    function step(direction) {
      const amount = Math.max(track.clientWidth * 0.8, 220);
      track.scrollBy({
        left: direction * amount,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    }

    $prev.on('click', () => step(-1));
    $next.on('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    $(window).on('resize', update);

    update();
  });
});
